import React, { useEffect, useState } from 'react'
import StatusActive from '../Status';
import GaugeComponent from 'react-gauge-component';

const Speedometer = ({ dataSource, DisplayNo }) => {

    const [valueData, setValueData] = useState(0);
    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (dataSource) {
                    // const response = dataSource.filter((item) => item.DisplayNo === DisplayNo);
                    if (dataSource || dataSource.length > 0) {
                        const convertValue = parseFloat(dataSource.Value1);
                        setValueData(convertValue);
                        setData([dataSource]);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }

        fetchData();
    }, [dataSource, DisplayNo]);

    // const gaugeData = [
    //     ['Label', 'Value'],
    //     ['rpm', valueData],
    // ];

    return (
        <div className="relative flex flex-col items-center p-4 w-full rounded-lg">
            <StatusActive setData={data} />
            {/* <Chart
                width={window.innerWidth > 768 ? 200 : 190}
                height={window.innerWidth > 768 ? 200 : 190}
                chartType="Gauge"
                data={gaugeData}
                options={{
                    redFrom: 1200,
                    redTo: 1500,
                    yellowFrom: 750,
                    yellowTo: 1200,
                    minorTicks: 5,
                    max: 1500,
                }}
            /> */}
            <div className="relative w-full flex items-center justify-center mb-4 drop-shadow-lg">
                <div className="absolute bottom-[-7px] border-2 border-gray-200 rounded-full">
                    <div className="w-[200px] h-[200px] border-[8px] border-gray-50 rounded-full"></div>
                </div>
                <p className="absolute bottom-[108px] right-50 text-lg font-medium">rpm</p>
                <GaugeComponent
                    style={{ width: '260px', padding: 0, margin: 0 }}
                    value={valueData}
                    maxValue={1500}
                    type="radial"
                    labels={{
                        tickLabels: {
                            type: "inner",
                            ticks: [
                                { value: 300 },
                                { value: 600 },
                                { value: 900 },
                                { value: 1200 },
                                { value: 1500 }
                            ]
                        },
                        valueLabel: {
                            style: { fill: 'black', fontSize: '38px', fontWeight: 500, textShadow: 0 } // Ubah warna teks nilai menjadi merah
                        }
                    }}
                    arc={{
                        gradient: true,
                        colorArray: ['#5BE12C', '#EA4228'], // Warna gradient
                        subArcs: [
                            { limit: 300 },
                            { limit: 600 },
                            { limit: 900 },
                            { limit: 1200 },
                            { limit: 1500 }
                        ],
                        padding: 0, // Padding antar sub-arc
                        width: 0.3 // Lebar arc
                    }}
                    pointer={{
                        elastic: true,
                        animationDelay: 0
                    }}
                />
            </div>

        </div>
    );
}

export default Speedometer;